{
  "fetchFailed": "Could not load connector accounts.",
  "createFailed": "Could not add the account.",
  "updateFailed": "Could not save the account.",
  "credentialFailed": "Could not replace the credential.",
  "deleteFailed": "Could not delete the account.",
  "footnote": "Importers choose an account by its ID when they set up a source. They never see its credential. Accounts from the operator profile file are changed in that file.",
  "origin": {
    "console": "Console",
    "profile": "Operator file"
  },
  "table": {
    "account": "Account",
    "provider": "Provider",
    "endpoint": "Provider account",
    "scopes": "Scopes",
    "credential": "Credential",
    "inUse": "In use",
    "privateCa": "Trusts a private CA certificate",
    "mountedFile": "File mounted on the workers",
    "replacedOn": "Replaced {{date}}",
    "notEditable": "This account covers scopes outside your grants, so you cannot change it."
  },
  "credentialFormats": {
    "token": "API token",
    "basic": "Username and password",
    "key_pair": "API key and application key"
  },
  "credentialFields": {
    "default": {
      "token": "API token",
      "username": "Username",
      "password": "Password",
      "api_key": "API key",
      "application_key": "Application key"
    },
    "aws": {
      "api_key": "Access key ID",
      "application_key": "Secret access key"
    },
    "kubernetes": {
      "token": "Service account token"
    },
    "mezmo": {
      "token": "Service account key"
    }
  },
  "actions": {
    "add": "Add account",
    "editSettings": "Edit settings",
    "replaceCredential": "Replace credential",
    "delete": "Delete account"
  },
  "empty": {
    "title": "No connector accounts yet",
    "message": "Add an account so importers can connect a source. The credential is sealed for the workers and never shown again.",
    "messageOff": "Accounts from the operator profile file appear here. Console accounts are off until an operator configures the credential key."
  },
  "warnings": {
    "consoleOffTitle": "Console accounts are off",
    "consoleOff": "An operator needs to configure the connector credential public key on the API and give the workers the matching private key file. Accounts in the operator profile file still work.",
    "profileFileTitle": "The operator profile file could not be read",
    "profileFile": "Accounts from it are missing from this list ({{reason}}).",
    "unreadableTitle": "Workers cannot open some credentials",
    "unreadable": "{{ids}} were sealed for a different worker key. Replace each credential to seal it to the current key.",
    "invalidTitle": "An account cannot be used",
    "invalidTitle_plural": "Some accounts cannot be used",
    "invalid": "{{ids}} no longer passes validation, often because an operator removed its host from the private host list. Connections that use it are paused. Fix or delete the account.",
    "invalid_plural": "{{ids}} no longer pass validation, often because an operator removed a host from the private host list. Connections that use them are paused. Fix or delete the accounts."
  },
  "form": {
    "addTitle": "Add a connector account",
    "editTitle": "Edit {{name}}",
    "addIntro": "Importers choose this account when they set up a source. They never see its credential.",
    "editIntro": "Changing the provider URL, provider account, scopes or CA certificate pauses every connection that uses this account until an importer reviews a new plan. Changing the display name does not.",
    "provider": "Provider",
    "chooseProvider": "Choose a provider",
    "chooseProviderFirst": "Choose a provider to see which credentials it accepts.",
    "accountId": "Account ID",
    "accountIdHelp": "Importers choose the account by this ID. Letters, numbers, dots, hyphens and underscores. It cannot be changed later.",
    "label": "Display name",
    "labelHelp": "Optional. Shown to importers next to the ID.",
    "accountIdentity": "Provider account",
    "accountIdentityHelp": "The organization, cluster or host this account reads from. Importers see it when they review a collection plan.",
    "baseUrl": "Provider URL",
    "baseUrlHelp": "HTTPS only, with no user name, password or query string. Workers will not connect to private, loopback or cloud metadata addresses unless an operator allows the host.",
    "scopes": "Scopes",
    "scopesHelp": "One service/environment pair per line, such as checkout/prod. Importers can only plan collection in these scopes.",
    "caCertificate": "CA certificate",
    "caCertificateHelp": "Optional PEM certificate, for providers signed by a private certificate authority.",
    "credentialHeading": "Credential",
    "credentialType": "Credential type",
    "credentialSealed": "The credential is sealed to the workers' key before it is stored. Nobody can read it back afterwards, administrators included."
  },
  "validation": {
    "provider": "Choose a provider.",
    "accountId": "Use letters, numbers, dots, hyphens and underscores only.",
    "accountIdentity": "Use letters, numbers, dots, colons, slashes, hyphens and underscores only.",
    "baseUrl": "Enter an HTTPS URL with no user name, password or query string.",
    "scopesEmpty": "Add at least one service/environment scope.",
    "scopesLine": "\"{{line}}\" is not a service/environment pair, such as checkout/prod.",
    "scopesMax": "List at most {{max}} scopes.",
    "credential": "Fill in every credential field."
  },
  "credentialModal": {
    "title": "Replace credential",
    "note": "Connections keep running and use the new credential from their next collection. No new plan is needed. The old credential is overwritten."
  },
  "deleteModal": {
    "title": "Delete {{name}}?",
    "inUse": "{{count}} connection uses this account and will pause at its next collection.",
    "inUse_plural": "{{count}} connections use this account and will pause at their next collection.",
    "unused": "No connections use this account.",
    "note": "The credential is destroyed and cannot be recovered. Evidence already collected stays until an importer disconnects the sources."
  },
  "toasts": {
    "added": "Account added. Importers can now choose it when they set up a source.",
    "saved": "Account saved.",
    "savedPaused": "Saved. {{count}} connection using this account will pause at its next collection until an importer reviews a new plan.",
    "savedPaused_plural": "Saved. {{count}} connections using this account will pause at their next collection until an importer reviews a new plan.",
    "credentialReplaced": "Credential replaced. Connections use it from their next collection.",
    "deleted": "Account deleted."
  },
  "flow": {
    "adding": "Adding…",
    "consoleOff": "Console accounts are turned off, so new accounts cannot be added here. Ask an operator to configure the credential key.",
    "steps": {
      "provider": {
        "eyebrow": "Step 1 of 3",
        "title": "Provider",
        "hint": "Where the account reads from",
        "description": "Choose the system this account connects to. The provider decides which credentials it accepts."
      },
      "connection": {
        "eyebrow": "Step 2 of 3",
        "title": "Connection",
        "hint": "Address and scopes",
        "description": "Name the account, say where to reach the provider, and list the services and environments importers may collect for."
      },
      "credential": {
        "eyebrow": "Step 3 of 3",
        "title": "Credential and review",
        "hint": "Secret and summary",
        "description": "Enter the credential, then check the settings before adding the account."
      }
    },
    "review": {
      "heading": "Review",
      "none": "None"
    }
  }
}
